import { generateNumberRanges, renderLabel } from '@/modules/authentication';

import { EducationLevelEnum } from '@packages/contracts';

export const recommendOptions = [
	{ label: 'New', name: 'recommend.new' },
	{ label: 'Closing Soon', name: 'recommend.closingSoon' },
];

export const featureOptions = [
	{ label: 'No experience necessary', name: 'feature.noExp' },
	{ label: 'Open to all levels of education', name: 'feature.allEducation' },
	{ label: 'Join within 1 Month', name: 'feature.join1m' },
	{ label: 'To hire 5 or more', name: 'feature.hire5' },
	{ label: 'Manager recruitment', name: 'feature.managerRecruit' },
	{ label: 'No document screening', name: 'feature.noDoc' },
	{ label: 'Online interviews', name: 'feature.onlineInterview' },
];

export const benefitsOptions = [
	{ label: '2 days off per-week', name: 'benefits.twoDaysWeek' },
	{ label: 'Weekend & holidays off', name: 'benefits.weekendHoliday' },
	{ label: 'Over 120 days off per-year', name: 'benefits.over120' },
	{ label: '5 days or more vacation OK', name: 'benefits.vacationOK' },
	{ label: 'Employee cafeteria / meal allowance', name: 'benefits.cafeteria' },
	{ label: 'Maternity leave available', name: 'benefits.maternity' },
	{ label: 'Car commuting', name: 'benefits.carCommute' },
	{ label: 'Motorcycle commuting', name: 'benefits.motorcycle' },
	{ label: 'Near station', name: 'benefits.nearStation' },
	{ label: 'Dress casual', name: 'benefits.dressCasual' },
	{ label: 'Comprehensive training system', name: 'benefits.training' },
];

export const jobFeatureOptions = [
	{ label: 'No location transfer', name: 'jobFeature.noTransfer' },
	{ label: 'Flexible work hours', name: 'jobFeature.flexHours' },
	{ label: 'Leave work on time', name: 'jobFeature.leaveOnTime' },
	{ label: 'Overtime up to 20 hours', name: 'jobFeature.overtime20' },
	{ label: 'Leave work by 6pm', name: 'jobFeature.leaveBy6' },
	{ label: 'Job using English', name: 'jobFeature.usingEnglish' },
	{ label: 'Job using other languages', name: 'jobFeature.usingOtherLang' },
	{ label: 'Work from home / remote work', name: 'jobFeature.remoteOK' },
	{ label: 'Full work from home / full remote work', name: 'jobFeature.fullRemote' },
];

export const companyFeatureOptions = [
	{ label: 'Listed company', name: 'companyFeature.listed' },
	{ label: 'Foreign-affiliated company', name: 'companyFeature.foreign' },
];

export const educationOptions = [
	{ label: 'No Education Required', value: 'NONE' },
	{ label: 'High School or Higher', value: EducationLevelEnum.enum.HIGH_SCHOOL },
	{ label: 'University of Higher', value: EducationLevelEnum.enum.UNIVERSITY },
	{ label: 'Graduate School or Higher', value: EducationLevelEnum.enum.GRADUATE_SCHOOL },
];

const start = 100_000,
	end = 2_500_000,
	step = 50_000;
const salaryRanges = generateNumberRanges(start, end, step);
export const salaryRangeOptions = salaryRanges.map(range => ({
	label: renderLabel(range),
	value: `${range.start}|||${range.end}`,
}));
